"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessServiceAvailabilityToJSON = exports.BusinessServiceAvailabilityFromJSONTyped = exports.BusinessServiceAvailabilityFromJSON = void 0;
var _1 = require("./");
function BusinessServiceAvailabilityFromJSON(json) {
    return BusinessServiceAvailabilityFromJSONTyped(json, false);
}
exports.BusinessServiceAvailabilityFromJSON = BusinessServiceAvailabilityFromJSON;
function BusinessServiceAvailabilityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dayOfWeek': json['dayOfWeek'],
        'timePeriods': (json['timePeriods'].map(_1.BusinessPeriodFromJSON)),
    };
}
exports.BusinessServiceAvailabilityFromJSONTyped = BusinessServiceAvailabilityFromJSONTyped;
function BusinessServiceAvailabilityToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dayOfWeek': value.dayOfWeek,
        'timePeriods': (value.timePeriods.map(_1.BusinessPeriodToJSON)),
    };
}
exports.BusinessServiceAvailabilityToJSON = BusinessServiceAvailabilityToJSON;
